export type IEmployeeTableFilterValue = string | string[];

export enum EMPLOYEE_EPF_STATUS {
  ALL = 'all',
  ENABLED = 'yes',
  DISABLED = 'no',
}

export const EMPLOYEE_EPF_STATUS_OPTIONS = [
  { value: EMPLOYEE_EPF_STATUS.ENABLED, label: 'Yes' },
  { value: EMPLOYEE_EPF_STATUS.DISABLED, label: 'No' },
];

export type IEmployeeTableFilters = {
  generalSearch: string;
  epf: string;
  baseSalary: number | null;
};

export type IEmployeeTableSort = {
  sortBy: string;
  order: 'asc' | 'desc';
};

export interface IEmployeeListItem {
  _id: string;
  name: string;
  employeeNumber: string;
  baseSalary: number;
  epf: boolean;
  updatedAt: string;
  status: string;
}

export interface IEmployeeItem {
  _id: string;
  name: string;
  employeeNumber: string;
  baseSalary: number;
  epf: boolean;
  status: string;
  createdAt: string;
  updatedAt: string;
}

export interface IEmployeeBaseSalaryRange {
  baseSalary: number;
}
